// @ts-nocheck — Pre-existing type errors (stale code drifted from refactored types / WIP).
// Suppressed to unblock the admin build; runtime unchanged. TODO(owner): restore type-safety.
import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

interface PlaceholderPageProps {
  title: string
  description: string
  roadmapItems: string[]
}

export function PlaceholderPage({ title, description, roadmapItems }: PlaceholderPageProps) {
  return (
    <div className="p-8 space-y-6">
      <div className="space-y-2">
        <div className="flex items-center gap-3">
          <h1 className="font-serif text-4xl font-semibold tracking-tight">{title}</h1>
          <Badge variant="outline" className="h-6">Roadmap</Badge>
        </div>
        <p className="text-muted-foreground text-lg max-w-2xl">{description}</p>
      </div>

      <Card className="border-dashed border-2 bg-muted/30">
        <CardHeader>
          <CardTitle>Feature Specs & Roadmap</CardTitle>
          <CardDescription>Key items coming in Phase 2 & 3</CardDescription>
        </CardHeader>
        <CardContent>
          <ul className="space-y-4">
            {roadmapItems.map((item, index) => (
              <li key={index} className="flex items-start gap-3">
                <div className="mt-1 h-2 w-2 rounded-full bg-primary shrink-0" />
                <span className="text-sm leading-relaxed">{item}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  )
}
